import { httpClient } from "./httpClient";

const base = "/api/convocatoria-plantillas";

export const listarPlantillas = (centroId) => {
  const params = centroId ? `?centro_id=${centroId}` : "";
  return httpClient.get(`${base}${params}`);
};
export const obtenerPlantilla = (id) => httpClient.get(`${base}/${id}`);
export const listarCamposDisponibles = () => httpClient.get(`${base}/campos`);
export const previsualizarCodigo = ({ cicloId, cursoId, numeroPromocion, plantillaId }) => {
  const params = new URLSearchParams();
  if (cicloId) params.append("ciclo_id", cicloId);
  if (cursoId) params.append("curso_id", cursoId);
  if (numeroPromocion) params.append("numero_promocion", numeroPromocion);
  if (plantillaId) params.append("plantilla_id", plantillaId);
  return httpClient.get(`${base}/previsualizar?${params.toString()}`);
};
export const crearPlantilla = (payload) => httpClient.post(base, payload);
export const actualizarPlantilla = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarPlantilla = (id) => httpClient.del(`${base}/${id}`);

const convocatoriaPlantillasService = {
  listar: listarPlantillas,
  obtener: obtenerPlantilla,
  listarCampos: listarCamposDisponibles,
  previsualizar: previsualizarCodigo,
  crear: crearPlantilla,
  actualizar: actualizarPlantilla,
  eliminar: eliminarPlantilla,
};

export default convocatoriaPlantillasService;
